import { render, staticRenderFns } from "./SettlementCheckedIcon.vue?vue&type=template&id=ba272f2e&scoped=true&"
import script from "./SettlementCheckedIcon.vue?vue&type=script&lang=js&"
export * from "./SettlementCheckedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba272f2e",
  null
  
)

export default component.exports